import React, { Fragment } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Layout as LayoutWrapper } from 'antd';
import useWindowSize from 'library/hooks/useWindowSize';
import LayoutProvider from 'context/LayoutProvider';
import {
  LISTING_POSTS_PAGE,
  SINGLE_POST_PAGE,
} from 'settings/constant';
import Header from './Header/Header';
import Footer from './Footer/Footer';
const { Content } = LayoutWrapper;

export default function Layout() {
  let location = useLocation();
  const { width } = useWindowSize();
  const singlePageUrlFromConst = SINGLE_POST_PAGE.split('/');
  const singlePageUrlFormLocation = location.pathname.split('/');

  return (
    <LayoutProvider>
      <Fragment>
        <Header />
        <Content>
          <Outlet />
        </Content>
        {location.pathname === LISTING_POSTS_PAGE ? (
          <div style={{ height: '33px' }} />
        ) : (
          <Fragment>
            <Footer />
            {singlePageUrlFormLocation[1] === singlePageUrlFromConst[1] && (
              <Fragment>
                {width < 1200 && <div style={{ height: '74px' }} />}
              </Fragment>
            )}
          </Fragment>
        )}
      </Fragment>
    </LayoutProvider>
  );
}
